import { useEffect, useState } from 'react';

/** Read the wall clock outside render; stop ticking when the view is closed. */
export function useCurrentTime(enabled = true) {
  const [now, setNow] = useState(Date.now);
  useEffect(() => {
    if (!enabled) return;
    const timer = window.setInterval(() => setNow(Date.now()), 1000);
    return () => window.clearInterval(timer);
  }, [enabled]);
  return now;
}
